<app-header></app-header>
<div [hidden]="isdisplay_city" style="background: #fff;position: relative;">
  <div class="map-top-header">
    <!-- map search is not built yet; the box stays hidden until it is -->
        <div class="bgtngrops">
          @for (btn of filterlayers(layerlist); track btn) {
            <div class="btn-group-toggle" data-toggle="buttons">
              <label class="btn headbtn" [attr.title]="btn.label?.toLowerCase() === 'zones' ? 'Zones are always shown' : null"
                [ngClass]="[ btn.checked ? 'active ' : '', btn.label?.toLowerCase() === 'zones' ? 'disabled btn-grey active' : 'btn-secondary']">
                <input type="checkbox" [checked]="btn.checked" (change)="changeToggleLayer(btn)"
                  [disabled]="btn.label?.toLowerCase() === 'zones'" />
                  {{ btn.label }}
                </label>
              </div>
            }
          </div>
          <div class="mv-right">
            <button type="button" class="btn btn-dark mv-back" routerLink="/maplist">Back</button>
            <div class="btn-map-icon">
              <button type="button" class="btnmap" (click)="zoomIn()" title="Zoom in" aria-label="Zoom in">
                <img src="assets/icons/icon-map-plus.svg" alt="" />
              </button>
              <button type="button" class="btnmap" (click)="zoomOut()" title="Zoom out" aria-label="Zoom out">
                <img src="assets/icons/icon-map-minus.svg" alt="" />
              </button>
              @if (canAddMarker) {
                <button type="button" class="btnmap btnmap-marker" (click)="addMarker()" title="Add a marker" aria-label="Add a marker">
                  <img src="assets/markers/v1/ready-to-use/fantasy/loc-09-point-of-interest-pin.svg" alt="" width="20" />
                </button>
              }
              @if (hasTerrain) {
                <button type="button" class="btnmap btnmap-export" (click)="exportPicture()" [disabled]="exportingPicture"
                  title="Save this view as a picture" aria-label="Save this view as a picture">
                  <img src="assets/icons/icon-download.svg" alt="" width="22" />
                </button>
              }
            </div>
          </div>
        </div>

        <div class="color-btn-box">
          @if (currentLayerName) {
            <h4 (click)="toggleCultureList()">
              {{ currentLayerName }}{{ currentLayerName.toLowerCase() === 'state' || currentLayerName.toLowerCase() ===
              'culture' ? 's' : '' }}
              <i class="fa" [ngClass]="isCultureVisible ? 'fa-angle-down' : 'fa-angle-up'"
              style="margin-left: auto; color: #fff;"></i>
            </h4>
          }


          @if (isCultureVisible) {
            <!-- If currentLayerName is 'heightmap', show static image -->
            @if (currentLayerName === 'heightmap') {
              <div>
                <div class="d-flex flex-column align-items-center justify-content-center g-10">
                  <img src="assets/images/heightmap-legend.png" alt="Heightmap Legend" style="width: 100%; padding: 10px;">
                  <p class="height-text" (click)="navigateToElevationLink()">ELEVATIONS &#40;Feet&#41;</p>
                </div>
              </div>
            } @else {
              @if (legendData && legendData.length > 0) {
                <ul>
                  @for (data of legendData; track data) {
                    <li (click)="onDynamicDataClick(data.full_name || data.name)" class="">
                      <span [ngStyle]="{ 'background-color': data.color }"></span>
                      <div class="pointer pointer-cursor-link custom-width-color-btn">{{ data.name }}</div>
                    </li>
                  }
                </ul>
              } @else {
                <p style="color: white; padding-left: 10px;">No data available</p>
              }
            }
            <!-- Fallback to normal legend display -->
          }
        </div>

        <div class="mapdetail-box" [class.open]="sideInfoBar" [class.hidden]="!sideInfoBar" #sideContent>
          <h4 class="mapdetail-header" (click)="toggleMapDetails()">
            MAP DETAILS
            <i class="fa" [ngClass]="isMapDetailsVisible ? 'fa-angle-down' : 'fa-angle-up'" style="margin-left: auto"></i>
          </h4>

          @if (isMapDetailsVisible) {
            <ul>
              @if (map_name) {
                <li>
                  World:&nbsp; <span class="pointer pointer-cursor-link pl-2" (click)="navigateToWikiWorld(map_name)">{{ map_name
                || "Unnamed Map" }}</span>
              </li>
            }
            @if (objectData) {
              @for (property of objectData | keyvalue : cellDetailsSort; track property) {
                @if (property.key !== 'id' && property.key !== 'burgs_data') {
            <li [class.bdr-top]="
                property.key === 'State' || property.key === 'Natural Resources'
              ">
                    {{ property.key }}:&nbsp;
                    <!-- Render resources as links if applicable -->
                    @if (isResourceField(property.key)) {
                      @if (splitResources(property.value)?.length > 0) {
                        @for (
                          item of splitResources(property.value); track
                          item; let i = $index) {
                          <div href="#" class="pointer pointer-cursor-link pl-2"
                            (click)="onResourceClick(item.name || item)"
                            (mouseenter)="showResourceTooltip($event, item)"
                            (mouseleave)="hideResourceTooltip()">
                            {{ item.name || item }}
                          </div>
                        }
                      } @else {
                        <span> None</span>
                      }
                    } @else {
                      @if (isLinkField(property.key)) {
                        @if (property?.value) {
                    <div class="pointer pointer-cursor-link pl-2" (click)="
                      navigateToDynamicLink(property.key, property.value)
                    ">
                            {{ property.value }}
                          </div>
                        } @else {
                          <span>None</span>
                        }
                      } @else {
                        <span> {{ property.value }}</span>
                      }
                    }
                    <!-- Fallback: normal value -->
                  </li>
                }
              }
            } @else {
              <li>No cell selected</li>
            }
          </ul>
        }
      </div>
      <div class="city-detail-box" [class.open]="isCityDetailsVisible" #sideContent>
        <h4 (click)="toggleCityMapDetails()" class="mapdetail-header">
          CITY details
          <i class="fa" [ngClass]="isCityDetailsVisible ? 'fa-angle-down' : 'fa-angle-up'" style="margin-left: auto"></i>
        </h4>

        @if (isCityDetailsVisible) {
          <ul>
            @if (cityData) {
              @for (property of cityData | keyvalue : cityDetailsSort; track property) {
                @if (property.key == 'City Name') {
                  <li (click)="navigateToCityNameWiki()">
                    {{ property.key }}:
                    <span class="pointer pointer-cursor-link pl-2">{{ property.value }}
                    </span>
                  </li>
                } @else {
                  <li>{{ property.key }}: {{ property.value }}</li>
                }
              }
            } @else {
              <li>No city selected</li>
            }
          </ul>
        }
      </div>
      <div class="layerpanel">
      <div #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed">
        <div class="card">

          <div class="card-content layerlst">
            <div class="form-group">
              @for (layer of layerlist; track layer) {
                <div class="form-check">
                  <input type="checkbox" class="form-check-input" id="exampleCheck1" (change)="changeHandler(layer)"
                    [checked]="getSelection(layer)">
                    <div class="fg-slider"><label class="form-check-label" for="exampleCheck1">{{layer.label}}</label>
                    @if (layer.name!=='foglayer') {
                      <input type="range" [(ngModel)]="layer.radius" class="form-range"
                        min="0" max="5" (change)="rangeChange(layer)" id="customRange2">
                    }
                    @if (layer.name ==='foglayer') {
                      <button type="button" class="btn btn-outline-primary color addfwar"
                      (click)="addFogLayer()" aria-controls="collapseExample">Add fog of war</button>
                    }
                    @if (layer.name ==='foglayer') {
                      <hr>
                      }
                    </div>
                  </div>
                }
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="mapWrap" id="map" [style.width]="'100vw'" [ngStyle]="{'height': windowmapheight}"
        (contextmenu)="onRightClickPopup($event)">

      </div>



    </div>

    @if (showMenu) {
      <!-- right-click menu: what to do at this spot -->
      <div class="map-ctx" [style.top.px]="menuPosition.y" [style.left.px]="menuPosition.x" role="menu">
        <div class="map-ctx-head">
          <span>At this spot</span>
          <button type="button" class="map-ctx-close" (click)="showMenu = false" aria-label="Close"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button>
        </div>
        <button type="button" class="map-ctx-item" role="menuitem" (click)="createContent()" [disabled]="isLoading"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" aria-hidden="true"><path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg><span>Create new content</span>@if (isLoading) {<i class="fa fa-spinner fa-spin"></i>}</button>
        <button type="button" class="map-ctx-item" role="menuitem" (click)="browseWpStore()" [disabled]="isLoading"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" aria-hidden="true"><path d="M4 9h16l-1.2 10.2a1 1 0 0 1-1 .8H6.2a1 1 0 0 1-1-.8L4 9Zm4 0V7a4 4 0 0 1 8 0v2" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg><span>Browse store content</span></button>
        <button type="button" class="map-ctx-item" role="menuitem" (click)="openPlaceContentModal()" [disabled]="isLoading"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" aria-hidden="true"><path d="M4 7h16v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7Zm-1-3h18v3H3V4Zm6 7h6" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" stroke-linecap="round"/></svg><span>Add from your vault</span></button>
      </div>
    }
    <div class="mapWrap" [hidden]="!isdisplay_city" id="map1" [style.height]="mapareaheight" [style.width]="mapareawidth"
      style="overflow: hidden;">


      <button type="button" class="btn btn-outline-primary citybackbtn" (click)="removeCityLayer()">
        Back
      </button>
    </div>
    <!-- no site footer on the map screen: the map uses the whole window -->

    <!-- Resource Hover Tooltip Card -->
    @if (hoveredResource) {
      <div class="resource-hover-card" [ngStyle]="tooltipStyle">
        <div class="resource-card-arrow"></div>
        <h4 class="resource-card-title">{{ hoveredResource.name }}</h4>
        @if (hoveredResource.description) {
          <p class="resource-card-desc">
            {{ hoveredResource.description }}
          </p>
        }
        @if (hoveredResource.production !== undefined || hoveredResource.economy !== undefined || hoveredResource.rarity !== undefined || hoveredResource.processing !== undefined) {
          <div class="resource-card-metrics">
            <div class="metric-item">
              <div class="metric-value">{{ hoveredResource.production || 0 }}</div>
              <div class="metric-label">Production</div>
            </div>
            <div class="metric-item">
              <div class="metric-value">{{ hoveredResource.economy || 0 }}</div>
              <div class="metric-label">Economy</div>
            </div>
            <div class="metric-item">
              <div class="metric-value">{{ hoveredResource.rarity || 0 }}</div>
              <div class="metric-label">Rarity</div>
            </div>
            <div class="metric-item">
              <div class="metric-value">{{ hoveredResource.processing || 0 }}</div>
              <div class="metric-label">Processing</div>
            </div>
          </div>
        }
      </div>
    }